import React from "react";

const Unknown = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4999 13C9.09163 13 9.57132 12.5203 9.57132 11.9285C9.57132 11.3368 9.09163 10.8571 8.4999 10.8571C7.90816 10.8571 7.42847 11.3368 7.42847 11.9285C7.42847 12.5203 7.90816 13 8.4999 13Z"
        fill="#666666"
      />
      <path
        d="M8.5 8.71429V8C8.99445 8 9.4778 7.85338 9.88893 7.57867C10.3 7.30397 10.6205 6.91353 10.8097 6.45671C10.9989 5.99989 11.0484 5.49723 10.952 5.01228C10.8555 4.52732 10.6174 4.08187 10.2678 3.73223C9.91814 3.3826 9.47268 3.1445 8.98773 3.04804C8.50277 2.95157 8.00011 3.00108 7.54329 3.1903C7.08648 3.37952 6.69603 3.69995 6.42133 4.11108C6.14662 4.5222 6 5.00555 6 5.5"
        stroke="#666666"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Unknown;
